// Every route the freeze flow owns or sends the customer to.
export const BILLING_PATH = '/account-settings/billing';
export const FREEZE_PATH = `${BILLING_PATH}/freeze`;
export const FREEZE_STATUS_PATH = `${FREEZE_PATH}/status`;
export const FREEZE_RESUME_PATH = `${BILLING_PATH}/resume`;
export const PAYMENT_METHODS_PATH = `${BILLING_PATH}/payment-methods`;
